import { useNavigate } from 'react-router-dom'
import UnitIcon from '@/assets/icons/inspection-icons/unit.svg'
import ArcticIcon from '@/assets/icons/inspection-icons/arctic.svg'

// Løft type selection page
const LoftSelection = () => {
  const navigate = useNavigate()

  const handleSelection = (type: 'sakkyndig' | 'sammeliste') => {
    sessionStorage.setItem('inspectionType', 'loft')
    sessionStorage.setItem('loftType', type)
    sessionStorage.removeItem('loftExitPath')
    
    if (type === 'sammeliste') {
      // Sammeliste has its own multi-step flow
      navigate('/samleliste-flow')
    } else {
      navigate('/company')
    }
  }

  return (
    <div className="min-h-full p-6 sm:p-8" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="max-w-4xl mx-auto">
        {/* Options — centered icon above label, stacked vertically */}
        <div className="flex flex-col gap-5 max-w-sm mx-auto">
          <button
            onClick={() => handleSelection('sakkyndig')}
            className="flex flex-col items-center justify-center gap-5 px-7 py-8 bg-white border border-slate-200 rounded-lg hover:border-[#1E3A5F] hover:shadow-md transition-all group"
          >
            <img src={UnitIcon} alt="Periodisk kontroll" className="h-32 object-contain" />
            <div className="text-center">
              <p className="text-xl font-semibold text-slate-700 group-hover:text-[#1E3A5F] transition-colors">Periodisk kontroll</p>
              <p className="text-base text-slate-400 mt-1">Sakkyndig inspeksjon</p>
            </div>
          </button>

          <button
            onClick={() => handleSelection('sammeliste')}
            className="flex flex-col items-center justify-center gap-5 px-7 py-8 bg-white border border-slate-200 rounded-lg hover:border-[#1E3A5F] hover:shadow-md transition-all group"
          >
            <img src={ArcticIcon} alt="Løst utstyr" className="h-32 object-contain" />
            <div className="text-center">
              <p className="text-xl font-semibold text-slate-700 group-hover:text-[#1E3A5F] transition-colors">Løst utstyr</p>
              <p className="text-base text-slate-400 mt-1">Samleliste</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default LoftSelection

